module.exports = __webpack_public_path__ + "img/Live-COVER.e2c84a6a.png";